import type { TenantAccess, TenantUserType } from "./Me.types";

// Derivações de gating de UI do Admin a partir do `tenantAccess` do /me.
// Espelham a ordem de autorização do backend (docs/permissions.md):
// primeiro tenantRole (owner/ownerViewer), depois managedComplexIds.

// Acesso à área Admin: owner, ownerViewer ou complexAdmin (role=user com pelo
// menos um complexo gerenciado). userType NÃO altera o acesso à área.
export const hasTenantAdminAccess = (
  tenantAccess: TenantAccess | null | undefined,
): boolean =>
  tenantAccess != null &&
  (tenantAccess.tenantRole === "owner" ||
    tenantAccess.tenantRole === "ownerViewer" ||
    tenantAccess.managedComplexIds.length > 0);

// Visibilidade da aba "Acessos": owner ou ownerViewer. complexAdmin puro
// (client ou tellus) e user puro NÃO veem a aba.
export const canSeeAdminAccessTab = (
  tenantAccess: TenantAccess | null | undefined,
): boolean =>
  tenantAccess != null &&
  (tenantAccess.tenantRole === "owner" ||
    tenantAccess.tenantRole === "ownerViewer");

// complexAdmin = role=user no tenant com pelo menos um complexo gerenciado.
// owner/ownerViewer não são complexAdmin (têm escopo total).
export const isComplexAdmin = (
  tenantAccess: TenantAccess | null | undefined,
): boolean =>
  tenantAccess != null &&
  tenantAccess.tenantRole === "user" &&
  tenantAccess.managedComplexIds.length > 0;

// userType ao qual um complexAdmin está restrito ao gerenciar/listar usuários.
// Espelha o escopo do backend (EnsureTenantAdminAccess + restrictUserType):
// complexAdmin só enxerga/gerencia usuários do próprio userType. owner/
// ownerViewer não restringem → null (sem filtro). Ordem de autorização
// (docs/permissions.md): tenantRole antes de userType.
export const complexAdminScopedUserType = (
  tenantAccess: TenantAccess | null | undefined,
): TenantUserType | null =>
  isComplexAdmin(tenantAccess) ? (tenantAccess as TenantAccess).userType : null;

// Visibilidade das abas de licença (Inventário de licenças / Alocações de
// licença): ocultas APENAS para complexAdmin `tellus`. Usuários `tellus`
// dispensam licença para módulos operacionais, então administradores `tellus`
// não gerenciam licenças. owner/ownerViewer (mesmo userType=tellus) e
// complexAdmin `client` continuam vendo as abas. Espelha o bloqueio do backend
// (assertNotTellusComplexAdmin → 403 nas rotas Y=15–18). Ordem de autorização
// (docs/permissions.md): tenantRole/escopo antes de userType.
export const canSeeLicenseTabs = (
  tenantAccess: TenantAccess | null | undefined,
): boolean => !(isComplexAdmin(tenantAccess) && tenantAccess?.userType === "tellus");
